import { ReactNode } from "react";

import { Button, Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";

const CheckboxGroup = (props: {
  options: { label: string | ReactNode; value: string }[];
  value: string[];
  onChange: (value: string[]) => void;
  renderPrefix?: (item: { label: string | ReactNode; value: string }) => ReactNode;
}) => {
  return (
    <FormGroup>
      {props.options.map((item, index) => {
        return (
          <div key={index} className="flex justify-between">
            <FormControlLabel
              label={
                <div className="flex items-center space-x-[8px]">
                  {props.renderPrefix?.(item)}
                  <Typography component="span" color="textPrimary">
                    {item.label}
                  </Typography>
                </div>
              }
              control={
                <Checkbox
                  checked={props.value.includes(item.value)}
                  value={item.value}
                  onChange={(e) => {
                    if (props.value.includes(item.value)) {
                      props.onChange(props.value.filter((item) => item !== e.target.value));
                    } else {
                      props.onChange([...props.value, e.target.value]);
                    }
                  }}
                />
              }
            />

            <Button
              onClick={() => {
                props.onChange([item.value]);
              }}
              sx={{
                textTransform: "capitalize",
              }}
            >
              only
            </Button>
          </div>
        );
      })}
    </FormGroup>
  );
};

export default CheckboxGroup;
